import React from 'react';
import { Container } from './ProfilePicturePlaceholder.styles';

export interface ProfilePicturePlaceholderProps {
  type?: 'initial' | 'icon';
  name?: string;
  size?: number;
  $backgroundColor?: string;
  altText: string;
}

const ProfilePicturePlaceholder: React.FC<ProfilePicturePlaceholderProps> = ({ type = 'initial', name, size, $backgroundColor, altText }) => {
  if (type === 'icon') {
    return (
      <Container size={size} $backgroundColor={$backgroundColor}>
        <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={altText}>
          <path d="M9.5 8C11.7486 8 13.5714 6.20914 13.5714 4C13.5714 1.79086 11.7486 0 9.5 0C7.25141 0 5.42857 1.79086 5.42857 4C5.42857 6.20914 7.25141 8 9.5 8Z" fill="#FAFDFF"/>
          <path d="M0 20C0 14.8453 4.25329 10.6667 9.5 10.6667C14.7467 10.6667 19 14.8453 19 20H0Z" fill="#FAFDFF"/>
        </svg>
      </Container>
    );
  }

  const getInitials = (name: string): string => {
    const words = name.trim().split(' ');

    if (words.length === 0) return '';
    if (words.length === 1) return words[0].charAt(0).toUpperCase();

    // Take first two words for initials
    return (
      words[0].charAt(0).toUpperCase() +
      words[1].charAt(0).toUpperCase()
    );
  };

  return (
    <Container size={size} $backgroundColor={$backgroundColor}>
      {name && getInitials(name)}
    </Container>
  );
};

export default ProfilePicturePlaceholder;
